(function () {
  'use strict';

  window.__LMJ_INITIAL_HREF__ = window.__LMJ_INITIAL_HREF__ || window.location.href;
  if (window.Attribution && window.Attribution.initialized) return;
  window.Attribution = window.Attribution || {};
  window.Attribution.initialized = true;

  var stored = AttributionStorage.read() || {};
  var userId = stored.lmj_user_id || AttributionUtils.getOrCreateUserId();
  var session = AttributionUtils.getOrCreateSessionId();
  var capturedAt = new Date().toISOString();
  var landingUrl = window.__LMJ_INITIAL_HREF__;
  var raw = AttributionUtils.getAllUrlParameters();
  var params = AttributionUtils.getUrlParameters();
  var clickKeys = ['gclid', 'gbraid', 'wbraid'];

  function copy(value) {
    return value == null ? value : JSON.parse(JSON.stringify(value));
  }

  function nonempty(value) {
    return value && typeof value === 'object' && Object.keys(value).length > 0;
  }

  function hasGoogleClick(value) {
    return value && clickKeys.some(function (key) {
      return typeof value[key] === 'string' && value[key].length > 0;
    });
  }

  function sameGoogleClick(a, b) {
    return hasGoogleClick(a) && hasGoogleClick(b) && clickKeys.every(function (key) {
      return (a[key] || '') === (b[key] || '');
    });
  }

  function legacyMeta() {
    return {
      captured_at: null,
      session_id: null,
      landing_url: null,
      source_basis: 'legacy_unverified',
      capture_status: 'legacy_unverified'
    };
  }

  function metadataFor(name) {
    if (stored.attribution_schema_version === 2 && stored[name + '_meta']) {
      return copy(stored[name + '_meta']);
    }
    return nonempty(stored[name]) ? legacyMeta() : null;
  }

  var firstTouch = copy(stored.first_touch || null);
  var lastTouch = copy(stored.last_touch || null);
  var firstRaw = copy(stored.first_touch_raw_params || {});
  var lastRaw = copy(stored.last_touch_raw_params || {});
  var firstMeta = metadataFor('first_touch');
  var lastMeta = metadataFor('last_touch');
  var lastGoogle = stored.attribution_schema_version === 2
    ? copy(stored.last_google_ads_touch || null) : null;
  var legacy = copy(stored.legacy_attribution || null);

  function clickCaptureTimes(values) {
    var known = [
      { params: firstTouch, meta: firstMeta },
      { params: lastTouch, meta: lastMeta },
      lastGoogle
    ];
    var times = {};
    clickKeys.forEach(function (key) {
      if (!values[key]) return;
      var earliest = capturedAt;
      known.forEach(function (record) {
        if (!record || !record.params || record.params[key] !== values[key] ||
            !record.meta || record.meta.capture_status !== 'observed') return;
        var previous = record.meta.click_id_captured_at && record.meta.click_id_captured_at[key];
        previous = previous || record.meta.captured_at;
        if (isFinite(Date.parse(previous)) && Date.parse(previous) < Date.parse(earliest)) {
          earliest = previous;
        }
      });
      times[key] = earliest;
    });
    return times;
  }

  if (stored.attribution_schema_version !== 2 && !legacy &&
      [firstTouch, lastTouch, firstRaw, lastRaw].some(nonempty)) {
    legacy = {
      first_touch: copy(firstTouch),
      last_touch: copy(lastTouch),
      first_touch_raw_params: copy(firstRaw),
      last_touch_raw_params: copy(lastRaw),
      capture_status: 'legacy_unverified'
    };
  }

  var hasClick = hasGoogleClick(params);
  var feed = AttributionUtils.isFeedAttribution(params);
  var conflicts = clickKeys.filter(function (key) { return Array.isArray(raw[key]); });
  var unusable = clickKeys.filter(function (key) {
    return Object.prototype.hasOwnProperty.call(raw, key) && !params[key];
  });
  var captureWarning = copy(stored.last_capture_warning || null);
  if (unusable.length) {
    captureWarning = {
      raw_params: copy(raw),
      unusable_click_ids: unusable,
      meta: {
        captured_at: capturedAt,
        session_id: session.id,
        landing_url: landingUrl,
        source_basis: 'unusable_parameters',
        capture_status: 'unusable'
      }
    };
  } else if (hasClick) {
    captureWarning = null;
  }
  var candidate = null;

  if (nonempty(params)) {
    var normalized = copy(params);
    if (hasClick) {
      normalized.utm_source = 'google';
      normalized.utm_medium = 'cpc';
      if (normalized.utm_campaign === 'sag_organic') delete normalized.utm_campaign;
      if (normalized.utm_content === 'sag_organic') delete normalized.utm_content;
    }
    candidate = {
      params: normalized,
      raw_params: copy(raw),
      meta: {
        captured_at: capturedAt,
        session_id: session.id,
        landing_url: landingUrl,
        source_basis: hasClick ? 'google_click_id' : (feed ? 'feed_marker' : 'utm'),
        capture_status: 'observed'
      }
    };
    if (conflicts.length) candidate.meta.conflicting_click_ids = conflicts;
    var identifierTimes = hasClick ? clickCaptureTimes(normalized) : null;

    if (hasClick && lastGoogle && lastGoogle.meta &&
        lastGoogle.meta.capture_status === 'observed' &&
        sameGoogleClick(candidate.params, lastGoogle.params)) {
      candidate = copy(lastGoogle);
    } else if (!hasClick && lastMeta && lastMeta.capture_status === 'observed' &&
        lastMeta.session_id === session.id &&
        AttributionUtils.areAttributionsEqual(lastTouch, normalized)) {
      candidate = { params: lastTouch, raw_params: lastRaw, meta: lastMeta };
    }
    if (hasClick) candidate.meta.click_id_captured_at = identifierTimes;

    if (!nonempty(firstTouch)) {
      firstTouch = copy(candidate.params);
      firstRaw = copy(candidate.raw_params);
      firstMeta = copy(candidate.meta);
    }
    lastTouch = copy(candidate.params);
    lastRaw = copy(candidate.raw_params);
    lastMeta = copy(candidate.meta);
    if (hasClick) lastGoogle = copy(candidate);
  }

  var payload = Object.assign(Object.create(null), stored, {
    attribution_schema_version: 2,
    lmj_user_id: userId,
    lmj_session_id: session.id,
    user_first_landing_url: stored.user_first_landing_url || landingUrl,
    session_entry_url: session.sessionEntryUrl || landingUrl,
    session_entry_referrer_external: session.sessionEntryReferrer || '',
    session_last_activity_at: session.lastActivityAt || capturedAt,
    first_touch: firstTouch,
    last_touch: lastTouch,
    first_touch_raw_params: firstRaw,
    last_touch_raw_params: lastRaw,
    first_touch_meta: firstMeta,
    last_touch_meta: lastMeta,
    last_google_ads_touch: lastGoogle,
    last_capture_warning: captureWarning,
    referrer: AttributionUtils.getReferrer() || null,
    consentMeta: AttributionConsent.getConsentMetadata(),
    device: AttributionUtils.getDeviceContext(),
    created_at: stored.created_at || capturedAt,
    updated_at: capturedAt
  });
  if (legacy) payload.legacy_attribution = legacy;
  AttributionStorage.storePayload(payload);

  function pushTruthLedgerToDataLayer() {
    // Check if TruthLedger exists
    if (typeof AttributionTruthLedgerEvents === 'undefined') {
      // Try again in 100ms
      setTimeout(pushTruthLedgerToDataLayer, 100);
      return;
    }

    if (!window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
    }

    try {
      var tlFields = AttributionTruthLedgerEvents.getAllFields();

      window.dataLayer.push({
        'event': 'truth_ledger_ready',
        'tl_paid_flag': tlFields.tl_paid_flag,
        'tl_click_id_type': tlFields.tl_click_id_type,
        'tl_consent_status': tlFields.tl_consent_status
      });

    } catch (e) {
      console.error("[Attribution Core] Error pushing TL data:", e);
      // Retry once more
      setTimeout(pushTruthLedgerToDataLayer, 200);
    }
  }

  // Start the process but don't block
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pushTruthLedgerToDataLayer);
  } else {
    // Use setTimeout to ensure other scripts have a chance to load
    setTimeout(pushTruthLedgerToDataLayer, 50);
  }

})();